var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "funnel-container" },
    [
      _vm.showMarquee
        ? _c(
            "div",
            { staticClass: "funnel-container__marquee" },
            [
              _c("PaywallMarquee", {
                attrs: {
                  content: [
                    "FINAL DAY OF MEGA SALE",
                    "⚡",
                    "FINAL DAY OF MEGA SALE",
                    "⚡",
                  ],
                  theme: "purple",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }